import * as React from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import HttpService from '../../../hooks/Https-services';
import {
  API_ROUTES,
  hasRole,
  PERIOD_TABS,
  ROLE_IDS,
} from '../../../utils/constant';
import {
  Backdrop,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  Pagination,
  Tab,
  Tabs,
  TextField,
} from '@mui/material';

import useCommonDetails from '../../../hooks/useCommonDetails';
import { DateRangePicker } from 'rsuite';
import GameRow from '../../GamesDashboard/GameRow';
import SelectFilters from '../../SelectFilters';
import { GlobalSearchContext } from '../../../context/GlobalSearchContext';
import moment from 'moment';

export default function PeriodsTable() {
  const [period, setPeriod] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [isRefresh, setIsRefresh] = React.useState(false);
  const [openRowId, setOpenRowId] = React.useState('');
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const itemsPerPage = 10;
  const currentUserInfo = useCommonDetails();
  const { _searchQuery: sQuery, _searchQueryTag: sQueryTag }: any =
    React.useContext(GlobalSearchContext);

  const [_searchQuery, _setSearchQuery] = React.useState('');
  const [debouncedQuery, setDebouncedQuery] = React.useState(_searchQuery);
  const [userInfo, setUserInfo] = React.useState<any[]>([]);
  const [moderatorInfo, setModeratorInfo] = React.useState<any>([]);
  const [selectModrator, setSelectModerator] = React.useState<any[]>([]);
  const [selectAssign, setSelectAssign] = React.useState<any[]>([]);
  const [currentTab, setCurrentTab] = React.useState('all');
  const { afterToday } = DateRangePicker;
  const ranges = [
    {
      label: 'Today',
      value: [new Date(), new Date()] as [Date, Date], // Explicitly typed as a tuple
    },
    {
      label: 'Yesterday',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 1)),
        new Date(new Date().setDate(new Date().getDate() - 1)),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
    {
      label: 'Last 30 Days',
      value: [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(),
      ] as [Date, Date], // Explicitly typed as a tuple
    },
  ];
  const [dateRangeReport, setDateRangeReport] = React.useState<[Date, Date]>([
    new Date(new Date().setDate(new Date().getDate() - 6)),
    new Date(),
  ]);

  const handleDateChangeReport = (value: any) => {
    setDateRangeReport(value);
  };

  const handleChangeCurrentTab = (
    event: React.SyntheticEvent,
    newValue: string
  ) => {
    setCurrentTab(newValue);
  };
  const handleChangeModerator = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectModerator(newValue);
  };

  const handleChangeAssign = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectAssign(newValue);
  };
  const handleSearchChange = (e: any) => {
    setDebouncedQuery(e.target.value);
  };
  React.useEffect(() => {
    const timer = setTimeout(() => _setSearchQuery(debouncedQuery), 500);
    return () => clearTimeout(timer);
  }, [debouncedQuery]);

  const fetchGamesList = React.useCallback(
    async (page: number = currentPage, limit: number = itemsPerPage) => {
      try {
        setLoading(true);
        const query: any = {
          search: _searchQuery,
          page: page,
          limit: limit,
        };
        if (hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])) {
          query.userId = currentUserInfo.userId;
        } else if (hasRole(currentUserInfo.roleId, [ROLE_IDS.MODERATOR])) {
          query.moderatorId = currentUserInfo.userId;
        }
        if (
          hasRole(currentUserInfo.roleId, [
            ROLE_IDS.ADMIN,
            ROLE_IDS.SUPER_ADMIN,
            ROLE_IDS.MODERATOR,
          ]) &&
          selectModrator.length > 0
        ) {
          query.moderatorId = selectModrator
            ?.map((value) => value.id)
            .join(',');
        }
        if (
          hasRole(currentUserInfo.roleId, [
            ROLE_IDS.ADMIN,
            ROLE_IDS.SUPER_ADMIN,
            ROLE_IDS.MODERATOR,
          ]) &&
          selectAssign.length > 0
        ) {
          query.userId = selectAssign?.map((value) => value.id).join(',');
        }
        if (currentTab != 'all') {
          query.status = currentTab;
        }
        if (dateRangeReport) {
          query.startDate = moment(dateRangeReport[0]).format('DD-MM-YYYY');
          query.endDate = moment(dateRangeReport[1]).format('DD-MM-YYYY');
        }

        const response = await HttpService.get(
          API_ROUTES.PeriodList + `?${new URLSearchParams(query).toString()}`
        );

        setTotalPages(response.data.data.totalPages);
        setPeriod(response.data.data.list);
      } catch (error: any) {
        console.error('Error fetching game list:', error);
      } finally {
        setLoading(false);
      }
    },
    [
      _searchQuery,
      currentPage,
      isRefresh,
      selectModrator,
      selectAssign,
      currentTab,
      dateRangeReport,
    ]
  );
  const fetchUserModInfo = React.useCallback(async () => {
    try {
      // Filter users whose role includes "moderator"
      const resModerator: any = await HttpService.get(
        `${API_ROUTES.allUser}?roleId=1,2&search=${sQuery}`
      );

      setModeratorInfo(resModerator.data.data.list);
    } catch (error: any) {
      console.error('Error fetching user info:', error);
    }
  }, [sQuery]);
  const fetchTaggerModInfo = React.useCallback(async () => {
    try {
      const query: any = {
        roleId: 3,
        search: sQueryTag,
      };
      if (
        hasRole(currentUserInfo.roleId, [ROLE_IDS.MODERATOR]) &&
        currentUserInfo.teamId
      ) {
        query.teamId = currentUserInfo.teamId;
      }

      const resTagger: any = await HttpService.get(
        API_ROUTES.allUser + `?${new URLSearchParams(query).toString()}`
      );
      // Filter users whose role includes "user"
      setUserInfo(resTagger.data.data.list);
    } catch (error: any) {
      console.error('Error fetching Tagger info:', error);
    }
  }, [sQueryTag]);

  React.useEffect(() => {
    fetchUserModInfo();
  }, [fetchUserModInfo]);
  React.useEffect(() => {
    fetchTaggerModInfo();
  }, [fetchTaggerModInfo]);
  React.useEffect(() => {
    fetchGamesList(); // Fetch data based on current page
    return () => {
      setPeriod([]);
    };
  }, [fetchGamesList]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };
  const clearFilter = () => {
    setSelectModerator([]);
    setSelectAssign([]);
    setDebouncedQuery('');
    setCurrentPage(1);
    setDateRangeReport([
      new Date(new Date().setDate(new Date().getDate() - 6)),
      new Date(),
    ]);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          padding: '20px 0',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={debouncedQuery}
            onChange={handleSearchChange}
            sx={{ width: '300px', height: '2.4375em !important' }} // Adjust the width as needed
          />
          <SelectFilters
            currentUserInfo={currentUserInfo}
            userInfo={userInfo}
            moderatorInfo={moderatorInfo}
            selectModrator={selectModrator}
            selectAssign={selectAssign}
            handleChangeModerator={handleChangeModerator}
            handleChangeAssign={handleChangeAssign}
          ></SelectFilters>
          <DateRangePicker
            character=" – "
            size="lg"
            shouldDisableDate={afterToday()}
            onChange={handleDateChangeReport}
            value={dateRangeReport}
            ranges={ranges}
          />
          <Box>
            <Button
              onClick={() => clearFilter()}
              variant="contained"
              sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
            >
              Clear Filter
            </Button>
          </Box>
        </Box>
      </Box>

      <Box>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={currentTab}
            onChange={handleChangeCurrentTab}
            aria-label="secondary tabs example"
          >
            <Tab value="all" label="All" />
            {PERIOD_TABS.map((status, index) => (
              <Tab
                key={index}
                value={status}
                label={status.replace(/_/g, ' ')}
              />
            ))}
          </Tabs>
        </Box>
        <GameRow
          periodList={period}
          userInfo={userInfo}
          handleApiToggle={() => {
            setIsRefresh(!isRefresh);
          }}
          fetchGamesList={fetchGamesList}
          isPeriodOnly={false}
        ></GameRow>
      </Box>

      {/* Pagination Component */}
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>

      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
